module.exports = __webpack_public_path__ + "media/application/images/landing_header/underlay_03-1633699fab0b187a450df399e1ca367e.png";